import { isValidPhoneNumber } from 'libphonenumber-js';

export function isPhoneValid(phone: string): boolean | undefined {
    return phone.length !== 0 ? isValidPhoneNumber(`+48${phone}`, 'PL') : undefined;
}